// Newsletter (Exponea) form
class NewsletterForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.emailInput = this.querySelector('input[type="email"]');
    this.errorContainer = this.querySelector('.newsletter-form__error');
    this.successContainer = this.querySelector('.newsletter-form__success');

    this.init();
  }

  init() {
    if (this.form) {
      this.form.addEventListener('submit', (event) => {
        event.preventDefault();
        this.handleSubmit();
      });
    }

    if (this.emailInput) {
      this.emailInput.addEventListener('input', () => {
        this.hideError();
      });
    }
  }

  async handleSubmit() {
    this.hideError();

    if (!this.emailInput || !this.emailInput.value) {
      const error_empty = window.newsletter.error_empty;
      this.showError(error_empty);
      this.emailInput.focus();
      return;
    }

    if (!this.validateEmail(this.emailInput.value)) {
      const email = this.emailInput.value;
      if (!email.includes('@')) {
        const error_format = window.newsletter.error_format?.replace('{email}', email);
        this.showError(error_format);
      } else {
        const error_empty = window.newsletter.error_empty;
        this.showError(error_empty);
      }
      this.emailInput.focus();
      return;
    }

    try {
      await this.trackBloomreachConsentAsync(this.emailInput.value);
      this.showSuccess();
      this.form.submit();
    } catch (error) {
      const genericError = window.newsletter.generic_error;
      this.showError(genericError);
      console.error('Error during tracking:', error);
    }
  }

  showError(message) {
    if (this.errorContainer) {
      this.errorContainer.textContent = message;
      this.errorContainer.classList.remove('hidden');

      if (this.emailInput) {
        this.emailInput.classList.add('has-error');
      }
    }
  }

  hideError() {
    if (this.errorContainer) {
      this.errorContainer.classList.add('hidden');

      if (this.emailInput) {
        this.emailInput.classList.remove('has-error');
      }
    }
  }

  showSuccess() {
    if (this.successContainer) {
      this.successContainer.classList.remove('hidden');
    }
  }

  validateEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  trackBloomreachConsentAsync(email) {
    return new Promise((resolve, reject) => {
      try {
        if (window.exponea && typeof window.exponea.track === 'function') {
          const userAgent = navigator.userAgent;
          const browserInfo = this.getBrowserInfo(userAgent);

          const payload = {
            location: window.location.href,
            os: browserInfo.os,
            browser: browserInfo.browser,
            device: browserInfo.device,
            action: 'new',
            source: 'public_api',
            message: 'pre-consent: footer',
            email: email,
            consent_list: [
              { action: 'accept', message: 'pre-consent: footer', valid_until: 'unlimited', category: 'email' },
              { action: 'accept', message: 'pre-consent: footer', valid_until: 'unlimited', category: 'sms' },
              {
                action: 'accept',
                message: 'pre-consent: footer',
                valid_until: 'unlimited',
                category: 'push_notifications',
              },
              {
                action: 'accept',
                message: 'pre-consent: footer',
                valid_until: 'unlimited',
                category: 'marketing_purposes',
              },
            ],
          };

          console.log('Bloomreach pre-consent event tracking for email:', email);

          if (typeof window.exponeaTrackSafe === 'function') {
            window.exponeaTrackSafe('pre-consent', payload);
          } else {
            window.exponea.track('pre-consent', payload);
          }

          resolve();
        } else {
          console.warn('Exponea tracking not available');
          resolve();
        }
      } catch (error) {
        console.error('Error during tracking:', error);
        reject(error);
      }
    });
  }

  getBrowserInfo(userAgent) {
    let os = 'Unknown';
    let browser = 'Unknown';
    let device = 'Other';

    // Detect OS
    if (/Windows/i.test(userAgent)) {
      os = 'Windows';
    } else if (/Macintosh|Mac OS X/i.test(userAgent)) {
      os = 'Mac OS X';
    } else if (/Linux/i.test(userAgent)) {
      os = 'Linux';
    } else if (/Android/i.test(userAgent)) {
      os = 'Android';
    } else if (/iPhone|iPad|iPod/i.test(userAgent)) {
      os = 'iOS';
    }

    // Detect browser
    if (/Chrome/i.test(userAgent) && !/Chromium|Edge|Edg|OPR|Opera/i.test(userAgent)) {
      browser = 'Chrome';
    } else if (/Firefox/i.test(userAgent)) {
      browser = 'Firefox';
    } else if (/Safari/i.test(userAgent) && !/Chrome|Chromium|Edge|Edg|OPR|Opera/i.test(userAgent)) {
      browser = 'Safari';
    } else if (/Edge|Edg/i.test(userAgent)) {
      browser = 'Edge';
    } else if (/Opera|OPR/i.test(userAgent)) {
      browser = 'Opera';
    }

    // Detect device type
    if (/Mobi|Android|iPhone|iPad|iPod/i.test(userAgent)) {
      if (/iPad/i.test(userAgent)) {
        device = 'Tablet';
      } else {
        device = 'Mobile';
      }
    } else if (/Tablet/i.test(userAgent)) {
      device = 'Tablet';
    } else {
      device = 'Desktop';
    }

    return { os, browser, device };
  }
}

customElements.define('newsletter-form', NewsletterForm);
